export default class RoutingPaths {
  // Auth Routes
  static LOGIN = "/";
  static SIGN_UP = "/sign-up";
  static CLIENT_SIGN_UP = "/client-sign-up";

  static FORGOT_PASSWORD = "/forgot-password";
  static FORGOT_PASSWORD_VALIDATE_TOKEN = `${this.FORGOT_PASSWORD}/validate-token`;
  static FORGOT_PASSWORD_CHANGE = `${this.FORGOT_PASSWORD}/change-password`;

  static PROFILE_VERIFY = "/profile-verification";

  static SMS_DOC_VIEW = "/NOSSPL/smsdoc";

  static PRIVACY_POLICY = "/privacy-policy";
  static TERMS_AND_CONDITIONS = "/terms-and-conditions";
  static APP_DETAILS = "/application-details";

  static PAGE_NOT_FOUND = "/page-not-found";

  // Dashboard Routes
  static DASHBOARD = "/dashboard";

  static APPOINTMENTS = `${this.DASHBOARD}/appointments`;
  static NEW_APPOINTMENT = `${this.DASHBOARD}/new-appointment`;
  static NEW_APPOINTMENT_WITHOUT_CLIENT = `${this.DASHBOARD}/new-appointment-without-client`;
  static APPOINTMENT_DETAILS = `${this.DASHBOARD}/appointment-details`;

  static CONSULTANTS = `${this.DASHBOARD}/consultants`;
  static ADD_CONSULTANTS = `${this.CONSULTANTS}/add-consultant-details`;
  static EDIT_CONSULTANTS = `${this.CONSULTANTS}/edit-consultant-details`;
  static CONSULTANT_DETAILS = `${this.CONSULTANTS}`;
  static CONSULTANT_HOLIDAYS = `${this.CONSULTANTS}/:consultantId/holidays`;

  static CONSULTANT_DETAIL = `${this.DASHBOARD}/personal-details`;
  static EDIT_PERSONAL_DETAILS = `${this.CONSULTANT_DETAIL}/edit-personal-details`;

  static CONTACTS = `${this.DASHBOARD}/contacts`;
  static CONTACT_DETAILS = `${this.CONTACTS}`;
  static CONTACT_UPDATE = `${this.CONTACTS}/update`;
  static CONTACT_ADD = `${this.CONTACTS}/add`;

  static CONTACT_DETAIL = this.DASHBOARD;
  static EDIT_DETAILS = `${this.CONTACT_DETAIL}/edit-details`;

  static MESSAGES = `${this.DASHBOARD}/messages`;

  static SCHEDULE = `${this.DASHBOARD}/schedule`;

  static PAYMENTS = `${this.DASHBOARD}/payments`;
  static PAYMENTS_TAB = `${this.DASHBOARD}/PaymentTab`;
  static CREATE_INVOICE = `${this.DASHBOARD}/create-invoice`;

  static REPORTS = `${this.DASHBOARD}/reports`;

  static ACCOUNT_SETTINGS = `${this.DASHBOARD}/account-settings`;
  static ADDRESS_AND_TIMINGS = `${this.ACCOUNT_SETTINGS}/address-and-timings`;
  static ADD_ADDRESS_AND_TIMINGS = `${this.ADDRESS_AND_TIMINGS}/add`;
  static EDIT_ADDRESS_AND_TIMINGS = `${this.ADDRESS_AND_TIMINGS}/edit`;
  static HOLIDAYS = `${this.ADDRESS_AND_TIMINGS}/holidays`;
  static GENERAL_INFORMATION = `${this.ACCOUNT_SETTINGS}/general-information/edit`;
  static BillCodes = `${this.ACCOUNT_SETTINGS}/bill-codes/add`;
  static ADMINS = `${this.ACCOUNT_SETTINGS}/admin-users`;
  static ReportsLayout = `${this.ACCOUNT_SETTINGS}/reports-layout`;
  static Exercise = `${this.ACCOUNT_SETTINGS}/exercise`;

  static ExerciseTemplate = `${this.ACCOUNT_SETTINGS}/exercise-Template`;
  static REFERRERS = `${this.ACCOUNT_SETTINGS}/referrers`;
  static PACKAGES = `${this.ACCOUNT_SETTINGS}/packages`;
  static BIRTHDAY_EMAIL_SETTING = `${this.ACCOUNT_SETTINGS}/birthday-email-setting`;

  static TREATMENTS = `${this.ACCOUNT_SETTINGS}/treatments`;
  static CALENDAR_CONSENT = `${this.ACCOUNT_SETTINGS}/calendar-consent`;

  static CONSENT_FORMS = `${this.ACCOUNT_SETTINGS}/consent-forms`;
  static ADD_CONSENT_FORMS = `${this.ACCOUNT_SETTINGS}/consent-forms/add-consent-form`;
  static EDIT_CONSENT_FORMS = `${this.ACCOUNT_SETTINGS}/consent-forms/edit-consent-form`;

  static CASE_PAPER_DESIGNS = `${this.ACCOUNT_SETTINGS}/case-paper-designs`;
  static CLIENT_ADDITIONAL_INFO = `${this.ACCOUNT_SETTINGS}/client-additional-info`;

  static ADD_EDIT_VACCINES = `${this.ACCOUNT_SETTINGS}/add-edit-vaccines`;

  static MEDICINE_INFORMATION = `${this.ACCOUNT_SETTINGS}/medicine-information`;

  static CERTIFICATE_TEMPLATES = `${this.ACCOUNT_SETTINGS}/certificates`;
  static ADD_CERTIFICATE_TEMPLATE = `${this.ACCOUNT_SETTINGS}/certificates/add-certificate`;
  static EDIT_CERTIFICATE_TEMPLATE = `${this.ACCOUNT_SETTINGS}/certificates/edit-certificate`;

  static HOSPITALIZATION = `${this.DASHBOARD}/hospitalization`;

  static HOSPITALIZATION_DETAILS = `${this.HOSPITALIZATION}`;

  static MEDICAL_PRODUCTS = `${this.DASHBOARD}/medical-products`;
  static MEDICAL_PRODUCT_DETAILS = `${this.MEDICAL_PRODUCTS}/medical-product-details`;
  static INVENTORIES = `${this.DASHBOARD}/inventories`;
  static VITALS = `${this.ACCOUNT_SETTINGS}/vitals`;
  static EDUCATIONAL_MATERIAL = `${this.ACCOUNT_SETTINGS}/educationalMaterial`;
}
